const {SIZE_LABELS} = require('./ppeSizes');
const KINDS = Object.freeze([
    {value: 'none', text: 'Размер не требуется', fields: []},
    {value: 'jacket', text: 'Куртка', fields: ['jacket', 'height']},
    {value: 'trousers', text: 'Брюки', fields: ['trousers', 'height']},
    {value: 'suit', text: 'Костюм', fields: ['jacket', 'trousers', 'height']},
    {value: 'shoes', text: 'Обувь', fields: ['shoes']},
    {value: 'gloves', text: 'Перчатки', fields: ['gloves']},
    {value: 'headwear', text: 'Головной убор', fields: ['headwear']},
    {value: 'kit', text: 'Комплект', fields: Object.keys(SIZE_LABELS)}
]);
function ppeConfig(type) {
    let workflow = type && type.workflow_config || {};
    if (typeof workflow === 'string') { try { workflow = JSON.parse(workflow); } catch (_) { workflow = {}; } }
    const catalog = workflow.itemCatalog || {};
    const ppe = catalog.ppe || {};
    return {enabled: catalog.enabled === true && catalog.type === 'materials' && ppe.enabled === true,
        material_group_ids: Array.isArray(ppe.material_group_ids) ? ppe.material_group_ids.map(Number).filter(id => Number.isInteger(id) && id > 0) : []};
}
function ppeFields(kind) { const value = KINDS.find(item => item.value === kind); return value ? value.fields : []; }
function ppeEligible(config, item) {
    if (item && item.ppe_data) return true;
    if (!config || !config.enabled) return false;
    if (item && (item.is_custom || item.isCustom)) return true;
    return (Array.isArray(config.material_ids) && config.material_ids.includes(Number(item && (item.catalog_item_id || item.id)))) || !config.material_group_ids.length || config.material_group_ids.includes(Number(item && (item.parent_group || item.group_id)));
}
function ppeText(data) {
    if (!data || !Array.isArray(data.recipients)) return '';
    const rows = data.recipients.map(row => [row.name, row.quantity ? `Кол-во: ${row.quantity}` : '',
        ...ppeFields(data.kind).filter(field => row.sizes && row.sizes[field]).map(field => `${SIZE_LABELS[field]}: ${row.sizes[field]}`),
        row.notes].filter(Boolean).join('; '));
    for (const row of data.stock || []) rows.push(['В запас', `Кол-во: ${row.quantity}`,
        ...ppeFields(data.kind).filter(field => row.sizes && row.sizes[field]).map(field => `${SIZE_LABELS[field]}: ${row.sizes[field]}`), row.notes].filter(Boolean).join('; '));
    return rows.join('\n');
}
const SYNC_LABELS = Object.freeze({updated: 'Карточка обновлена', unchanged: 'Размер уже указан в карточке', forbidden: 'Только в заявке: нет права редактирования СИЗ', conflict: 'Карточка не обновлена: разные размеры в позициях', stale: 'Карточка не обновлена: размер изменён другим пользователем', missing: 'Карточка сотрудника не найдена'});
function copyPpeSnapshot(data) {
    if (!data) return null;
    const result = JSON.parse(JSON.stringify(data));
    delete result.sync_results;
    result.recipients.forEach(row => { row.dirty_fields = []; });
    return result;
}
module.exports = {copyPpeSnapshot, SIZE_LABELS, KINDS, ppeFields, ppeConfig, ppeEligible, ppeText, SYNC_LABELS};
